import { Breadcrumbs, Container, H1, Loader, Tabs } from '@itds/elements/index.js';
import React, { useContext, useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';

import Admins from '@carrier/pages/carriers/Admins';
import { Api } from '@carrier/utils/Api';
import { CarrierContext } from '@carrier/contexts/CarrierContext';
import Form from '@carrier/pages/carriers/forms/Show';
import Forms from '@carrier/pages/carriers/Forms';
import General from '@carrier/pages/carriers/General';
import LifeDxProfile from '@carrier/pages/carriers/LifeDxProfile';
import LifeQuote from '@carrier/pages/carriers/life_quotes/Show';
import LifeQuotes from '@carrier/pages/carriers/LifeQuotes';
import AnnuityQuote from '@carrier/pages/carriers/annuity_quotes/Show';
import AnnuityQuotes from '@carrier/pages/carriers/AnnuityQuotes';
import LtcQuoteVersions from '@carrier/pages/carriers/LtcQuoteVersions';
import Notification from '@carrier/components/Notification';
import Products from '@carrier/pages/carriers/Products';
import Vendor from '@carrier/pages/carriers/vendors/Show';
import Vendors from '@carrier/pages/carriers/Vendors';

const Show = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { notification, setNotification } = useContext(CarrierContext);
  const [carrier, setCarrier] = useState({});
  const [lifeDxProfile, setLifeDxProfile] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    Api.loadCarrier(params.id).then(({ data }) => {
      setCarrier(data);

      Api.loadLifeDxProfile(params.id).then(({ data }) => {
        setLifeDxProfile(data[0]);
        setLoading(false);
      });
    });
  }, []);

  const loadCarrier = () => {
    setLoading(true);

    Api.loadCarrier(params.id).then(({ data }) => {
      setCarrier(data);

      Api.loadLifeDxProfile(params.id)
        .then(({ data }) => {
          setLifeDxProfile(data[0]);
          setLoading(false);
          setNotification({
            message: 'Successfully Saved',
            type: 'success'
          });
        })
        .catch(() => {
          setTimeout(() => {
            setNotification({
              message: 'Unable to save at this time',
              type: 'error'
            });
          }, 2000);
        });
    });
  };

  const props = {
    carrier,
    lifeDxProfile,
    loadCarrier
  };

  return loading ? (
    <Loader />
  ) : (
    <Container>
      <Notification {...notification} />
      <H1>{carrier.name}</H1>
      <Breadcrumbs
        crumbs={[{ label: 'All Carriers', onClick: navigate.bind(null, '/carriers') }]}
        current={carrier.name}
      />

      <Tabs
        tabs={[
          {
            isActive: window.location.hash === `#/carriers/${carrier.id}`,
            label: 'General',
            onClick: navigate.bind(null, '')
          },
          {
            isActive: window.location.hash.includes('admins'),
            label: 'Admins',
            to: 'admins'
          },
          {
            isActive: window.location.hash.includes('vendors'),
            label: 'Vendors',
            to: 'vendors'
          },
          {
            isActive: window.location.hash.includes('products'),
            label: 'Products',
            to: 'products'
          },
          {
            isActive: window.location.hash.includes('forms'),
            label: 'Forms',
            to: 'forms'
          },
          {
            isActive: window.location.hash.includes('annuity_quotes'),
            label: 'Annuity Quotes',
            to: 'annuity_quotes'
          },
          {
            isActive: window.location.hash.includes('life_quotes'),
            label: 'Life Quotes',
            to: 'life_quotes'
          },
          {
            isActive: window.location.hash.includes('ltc_quote_versions'),
            label: 'LTC Quote Versions',
            to: 'ltc_quote_versions'
          },
          {
            isActive: window.location.hash.includes('lifedx_profile'),
            label: 'LifeDX Profile',
            to: 'lifedx_profile'
          }
        ]}
      />

      <div style={{ padding: '40px 20px' }}>
        <Routes>
          <Route element={<General {...props} />} index={true} />
          <Route element={<Admins {...props} />} path='admins' />
          <Route element={<Vendors {...props} />} path='vendors' />
          <Route element={<Vendor {...props} />} path='vendors/:vendor_id/*' />
          <Route element={<Products {...props} />} path='products' />
          <Route element={<Forms {...props} />} path='forms' />
          <Route element={<Form {...props} />} path='forms/:form_id/*' />
          <Route element={<LifeQuotes {...props} />} path='life_quotes' />
          <Route element={<LifeQuote {...props} />} path='life_quotes/:version_id/*' />
          <Route element={<AnnuityQuotes {...props} />} path='annuity_quotes' />
          <Route element={<AnnuityQuote {...props} />} path='annuity_quotes/:version_id/*' />
          <Route element={<LtcQuoteVersions {...props} />} path='ltc_quote_versions' />
          <Route element={<LifeDxProfile {...props} />} path='lifedx_profile' />
        </Routes>
      </div>
    </Container>
  );
};

export default Show;
